import { Link } from "react-router-dom";

export interface TopicItem {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  count: number;
}

export default function TopicGrid({ topics }: { topics: TopicItem[] }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {topics.map((topic) => (
        <Link
          key={topic.id}
          to="/news"
          className="group relative block h-52 overflow-hidden rounded-lg cursor-pointer"
        >
          <img
            src={topic.cover}
            alt={`${topic.title} 专题封面`}
            title={`${topic.title} - 78动漫专题合集`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/40 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-4">
            <span className="inline-flex items-center gap-1 rounded-full bg-accent-500/90 px-2.5 py-0.5 text-xs font-medium text-background-50">
              <i className="ri-folder-2-line" />
              {topic.count} 篇内容
            </span>
            <h3 className="mt-2 font-heading text-lg font-bold text-background-50">{topic.title}</h3>
            <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-background-200">{topic.subtitle}</p>
          </div>
          <span className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-background-50/20 text-background-50 opacity-0 transition-opacity group-hover:opacity-100">
            <i className="ri-arrow-right-up-line text-lg" />
          </span>
        </Link>
      ))}
    </div>
  );
}